import Splide from '@splidejs/splide';

const storeSlidy = new Splide('.splide-store-slidy--desktop', {

  type: 'loop',
  gap: '12px',
  padding: '48px',

});

storeSlidy.mount();

const storeSlidyMobile = new Splide('.splide-store-slidy--mobile', {
  type: 'loop',
  perPage: 1,
  gap: '12px',
  focus: 'center',
});

storeSlidyMobile.mount();

const splideFeatured = new Splide('.splide-featured-resources', {
  type: 'loop',
  perPage: 7,
  perMove: 1,
  gap: 24,
  pagination: false,

  breakpoints: {
    1400: { perPage: 5 },
    1000: { perPage: 4 },
    800:  { perPage: 3 },
    600:  { perPage: 2 },
    480:  { perPage: 1 }
  }
});

splideFeatured.on('overflow', function (isOverflow) {
  splideFeatured.options = {
    type: isOverflow ? 'loop' : 'slide',
    arrows: isOverflow,
    drag: isOverflow,
  };
});

splideFeatured.mount();